import SubjectContent from '../shared/SubjectContent';
import { finalDesign } from './finalDesign';

export default function KoreanContent() {
    return <SubjectContent page="kor" design={finalDesign} />;
}
